import React, { Component } from 'react';

import './index.css';

import request from '../client/client';
import Recaptcha from 'react-recaptcha';

import logo from '../../Logo_Gregg.svg';
import errorIcon from '../../errorVerm.png'


// create a variable to store the component instance
let recaptchaInstance;

// create a reset function
const resetRecaptcha = () => {
  recaptchaInstance.reset();
};

class CupomChecker extends Component {

  state = {
    couponError: "",
    captchaId: null
  }
  
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  

  validateCupom = async (e) => {
    e.preventDefault();

    this.setState({ couponError: "" })
    
    // if (this.state.captchaId) {
      try{
        const cupom = await request.get(`/cashiers/coupon/${this.state.cupom}`)

        if(!cupom.data.redeem.alreadyUsed) {
          try{
            const clientName = await request.get(`/users/${cupom.data.redeem.userRedeem}`);
            this.props.history.push({
              pathname: '/cupomData', 
              state: { 
                name: clientName.data.name,
                item: cupom.data.item.name,
                date: cupom.data.redeem.dateOfRedeem,
                couponCode: this.state.cupom
            }});
          } catch(error) {
            this.setState({
              couponError: "Nossos sistemas estão passando por problemas, tente mais tarde"
            });
            // resetRecaptcha();
          }

        } else {
          this.setState({
            couponError: "Código inválido"
          });
          // resetRecaptcha();
        }
      } catch(error) {
        this.setState({
          couponError: "Nossos sistemas estão passando por problemas, tente mais tarde"
        });
        // resetRecaptcha();
      }
    // } else {
    //   this.setState({
    //     couponError: "Você esqueceu de mostrar que você não é um robô. Marque a caixa acima e tente novamente."
    //   })
    // }
  }

  // specifying verify callback function
  verifyCallback = (response) => {
    this.setState({ captchaId: response });
  };

  render() {
    return (
      <div className="text-center">
        <img className="gregg-logo" src={logo} alt="gregg" width="135"/>
        <div className="content-container text-left">
          <h2>Olá</h2>
          <p>Confira se o cupom do seu cliente é válido!</p>
          <form onSubmit={this.validateCupom}>
          <input
            className="form-item form-secondary m-auto"
            placeholder="Insira aqui o código do cupom"
            name="cupom"
            type="text"
            onChange={this.handleChange}
          />
          {/* <Recaptcha
            className="m-auto ml-2"
            sitekey="6LckuGQUAAAAAKtu8WtufgwU3jlpQHz2ibIYa1Fu"
            render="explicit"
            hl="pt-br"
            ref={e => recaptchaInstance = e}
            verifyCallback={this.verifyCallback}
          /> */}
          {
          !!this.state.couponError &&
          <div className="error-message red m-auto">
            <img src={errorIcon} alt="ícone de erro"/>
            {this.state.couponError}
          </div>
          }
          <input
            className="form-submit check"
            value="Conferir"
            type="submit"
          />
        </form>
        </div>
      </div>
    )
  }
}

export default CupomChecker;



// WEBPACK FOOTER //
// ./src/components/cupomchecker/index.js